import api from 'config/Api/Api';

const baseEndpoint = 'v1/participant';

export default {

  getParticipants( params ) {
    return api.get( baseEndpoint, params );
  },

  getParticipant( id ) {
    return api.get( `${baseEndpoint}/${id}` );
  },

  saveParticipant( data ) {
    return api.post( baseEndpoint, data );
  },

  updateParticipant( id, data ) {
    return api.put( `${baseEndpoint}/${id}`, data );
  },

  deleteParticipant( id ) {
    return api.delete( `${baseEndpoint}/${id}` );
  },
};
